import React, { useRef, useState } from 'react'
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { ArrowLeft2, ArrowRight2 } from "iconsax-react";

export const Calendar = ({ events, handleEventClick, title }) => {
  const [calendarView, setCalendarView] = useState("dayGridMonth");
  const calendarRef = useRef(null);

  const handleViewChange = (view) => {
    setCalendarView(view);
    const calendarApi = calendarRef.current.getApi(); // Get the FullCalendar API
    calendarApi.changeView(view); // Change the view programmatically
  };

  return (
    <div className="border">
      <div className="p-3 border-b flex justify-between items-center">
        <div className="font-medium text-[17px]">{title}</div>

        <div className="flex gap-3">
          <select
            className="border px-3 py-2 text-[14px] outline-none"
            value={calendarView}
            onChange={(e) => handleViewChange(e.target.value)} // Trigger view change on select
          >
            <option value="dayGridMonth">Month view</option>
            <option value="timeGridWeek">Week view</option>
            <option value="timeGridDay">Day view</option>
          </select>
        </div>
      </div>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]} // Include timeGridPlugin for week and day views
        initialView={calendarView} // Use calendarView state for the initial view
        weekends={true}
        events={events}
        height={500}
        ref={calendarRef}
        //eventContent={EventComponent}
        eventClick={handleEventClick}
        headerToolbar={false}
      />
    </div>
  );
}
